import axios from '@/services/api'

/**
 * @returns {Promise<Object>}
 */
export const fetchCategories = () => {
	const url = `/api/categories`
	return axios.get(url)
}
